import config from "../config";

// Static imports for DJ Rise assets
import djrBoatScienceWorld from "../assets/djr/icons/boat-science-world.jpg";
import djrGardenTableSetup from "../assets/djr/icons/garder-table-setup.jpeg";
import djrAvatarDJVinyl from "../assets/djr/icons/Avatar-DJ-vinyl-1.jpg";
import djrAvaNov25 from "../assets/djr/icons/ava-nov-25.jpg";
import djrLogo from "../assets/djr/icons/logo.png";
import djrMixcloudSvg from "../assets/djr/icons/mixcloud-svgrepo-com.svg";
import djrVimeoSvg from "../assets/djr/icons/vimeo-vimeo-svgrepo-com.svg";
import djrPioneerDJSet from "../assets/djr/pioneerdjset.jpg";
import djrPrivateParty2 from "../assets/djr/private-party-2.png";
import djrPrivateParty3 from "../assets/djr/private-party-3.png";
import djrUpcomingEvent from "../assets/djr/upcoming-event.png";

// Static imports for Rise DJ assets
import risemnBoatScienceWorld from "../assets/risemn/icons/boat-science-world.jpg";
import risemnGardenTableSetup from "../assets/risemn/icons/garder-table-setup.jpeg";
import risemnAvatarDJVinyl from "../assets/risemn/icons/Avatar-DJ-vinyl-1.jpg";
import risemnAvaNov25 from "../assets/risemn/icons/ava-nov-25.jpg";
import risemnLogo from "../assets/risemn/icons/logo.png";
import risemnMixcloudPng from "../assets/risemn/icons/mixcloud.png";
import risemnSoundCloudSvg from "../assets/risemn/icons/soundcloud.svg";
import risemnVimeoPng from "../assets/risemn/icons/vimeo.png";
import risemnUpcomingEvent from "../assets/risemn/upcoming-event.png";

// Helper function to get brand-specific asset paths
export const getAssetPath = (assetName) => {
  const brandSlug = config.brand.slug;

  // This function is kept for backward compatibility but not recommended
  console.warn("getAssetPath is deprecated, use getBrandAssets() instead");
  return null;
};

// Specific asset getters for commonly used assets
export const getBrandAssets = (brandSlugOverride) => {
  const brandSlug = brandSlugOverride || config.brand.slug;

  if (brandSlug === "djr") {
    return {
      // Common icons
      boatScienceWorld: djrBoatScienceWorld,
      gardenTableSetup: djrGardenTableSetup,
      avatarDJVinyl: djrAvatarDJVinyl,
      avaNov25: djrAvaNov25,
      logo: djrLogo,

      // Social icons
      mixcloudSvg: djrMixcloudSvg,
      vimeoSvg: djrVimeoSvg,

      // Brand-specific assets
      pioneerDJSet: djrPioneerDJSet,
      privateParty2: djrPrivateParty2,
      privateParty3: djrPrivateParty3,
      upcomingEvent: djrUpcomingEvent,
    };
  } else if (brandSlug === "risemn") {
    return {
      // Common icons
      boatScienceWorld: risemnBoatScienceWorld,
      gardenTableSetup: risemnGardenTableSetup,
      avatarDJVinyl: risemnAvatarDJVinyl,
      avaNov25: risemnAvaNov25,
      logo: risemnLogo,

      // Social icons
      mixcloudSvg: risemnMixcloudPng,
      vimeoSvg: risemnVimeoPng,
      soundCloudSvg: risemnSoundCloudSvg,

      // Brand-specific assets (Rise DJ doesn't have these)
      pioneerDJSet: null,
      privateParty2: null,
      privateParty3: null,
      upcomingEvent: risemnUpcomingEvent,
    };
  }

  return {};
};

// Fallback function for missing assets (deprecated - use static imports)
export const getAssetWithFallback = (primaryPath, fallbackPath) => {
  console.warn(
    "getAssetWithFallback is deprecated, use getBrandAssets() instead",
  );
  return null;
};
